import { render, staticRenderFns } from "./SystemCommunicationsEmailEditor.vue?vue&type=template&id=52f9836b&scoped=true"
import script from "./SystemCommunicationsEmailEditor.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsEmailEditor.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunicationsEmailEditor.vue?vue&type=style&index=0&id=52f9836b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f9836b",
  null
  
)

export default component.exports